import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, UntypedFormArray, UntypedFormBuilder, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { OpenDialogGoToOfferSessionComponent } from 'app/components/dialog/open-dialog-go-to-offer-session/open-dialog-go-to-offer-session.component';
import { CodeClub } from 'app/shared/models/class/club/club';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { Parameter } from 'app/shared/models/class/parameter/parameter';
import { PracticePlace } from 'app/shared/models/class/practice-place/PracticePlace';
import { PricingOffer, Pricing, Discount } from 'app/shared/models/class/pricing-offer/pricingOffer';
import { TagType, Tag } from 'app/shared/models/class/tags/tag';
import { Universe } from 'app/shared/models/class/universe/universe';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { ClubService } from 'app/shared/services/club/club.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { ImgOfferDefaultService } from 'app/shared/services/img-offer-default/img-offer-default.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { ParametersService } from 'app/shared/services/parameters/parameters.service';
import { PracticePlaceService } from 'app/shared/services/practice-place/pratcice-place.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { environment } from 'environments/environment';
import { Observable, Subject, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

const reader = new FileReader();

@Component({
  selector: 'app-admin-offer-edit',
  templateUrl: './admin-offer-edit.component.html',
  styleUrls: ['./admin-offer-edit.component.scss']
})
export class AdminOfferEditComponent extends SubscriptionBaseComponent implements OnInit {
  mode: string;
  @Input() offer: FullOffer;
  @Input() tempoPricing: boolean;
  @Input() clubCode: string;

  @Output() offerPreviewUpdate = new EventEmitter<FullOffer>();
  @Output() imageUpdate = new EventEmitter<any>();
  @Output() editFinished = new EventEmitter<boolean>();
  @Output() switchToSession = new EventEmitter<FullOffer>();

  tabSelectedIndex = 0;

  newOffer: FullOffer;
  tempoPricingExist: boolean;
  isReturn = false;

  userConnected: any;

  form: FormGroup;
  pricingForm: FormGroup;
  filteredOptions: Observable<string[]>;

  offerPreview = new FullOffer();
  file: any;

  tags: TagType[];
  filteredTags: TagType[];
  tagsSelected: Tag[];
  tagsSelectedString: string[] = [];
  tagsSelectedSecondMainTag: Tag[];
  tagsSelectedThirdMainTag: Tag[];
  mainTags: Tag[] = [];

  clubs: CodeClub[];

  isLoading = false;
  oldImage: string;

  universes: Universe[] = [];
  parameters: Parameter[] = [];

  filteredParameters: Parameter[] = [];

  color: ThemePalette = 'primary';
  universesSelected: Universe[] = [];

  typeOfInput: string[] = ['texte', 'date', 'heure', 'valeur min/max', 'liste', 'checkbox'];


  offerById: FullOffer;
  offerKey: any;
  practicesClub: PracticePlace[];
  parametersDefault = this.parametersService.numberOfParametersRequired;
  tooltipExternUrl: string;
  offerParameterUpdatable = true;
  offerSessionSettable = true;

  maxFiftyLength = 50;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private dataService: DataService,
    private formBuilder: UntypedFormBuilder,
    private imgOfferDefault: ImgOfferDefaultService,
    private dialog: MatDialog,
    private authService: AuthService,
    private tooltip: TooltipService,
    private offerService: OfferService,
    private faIconService: FaiconService,
    private uiService: UiService,
    private parametersService: ParametersService,
    private practicePlaceService: PracticePlaceService,
    private clubService: ClubService,
    private parametersSrv: ParametersService

  ) {
    super()
  }


  ngOnInit(): void {
    if (this.offer) {
      this.isLoading = true;
      this.mode = "edit"
    }
    else {
      this.mode = "add";
    }

    this.initComponent();
    this.initSub();
    this.getClubs();

    if (this.userConnected.role === 'admin' && (this.offer || this.clubCode)) {
      this.f.clubCode.setValue(this.offer ? this.offer.clubCode : this.clubCode);
      this.f.clubCode.disable();
    }
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this.subscription.unsubscribe();
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    if (this.userConnected.role === 'club') {
      this.getPracticePlaceByClub();
    }

    if (this.offer)
      this.offerPreview = this.offer;
    else
      this.offerPreview = new FullOffer();
  }

  private initSub(): void {
    this.initForm();
    this.prepareOfferToForm()

    this.subscription
      .add(
        this.dataService.tagSelectedAddOffer.subscribe({
          next: tagsSelected => {
            this.tagsSelected = tagsSelected;
          }
        })
      )

      .add(
        this.parametersSrv.getParametersActive().subscribe((parametersFromSrv: Parameter[]) => {
          this.parameters = parametersFromSrv;
          this.filteredParameters = [...this.parameters];
        })
      )
  }

  private getClubs(): void {
    this.clubService.getClubs().subscribe({
      next: clubs => {
        this.clubs = clubs?.sort((a, b) => a.code.localeCompare(b.code));
        this.setValueForm();
      }
    });
  }

  private initForm(): void {
    this.form = this.formBuilder.group({
      offerName: [this.offer?.offerName ?? '', Validators.required],
      clubCode: [this.offer?.clubCode ?? '', Validators.required],
      image: [''],
      practicePlace: [this.offer?.practicePlace ?? ''],
      description: [this.offer?.description ?? '', Validators.required],
      offerClubURL: [this.offer?.offerClubURL ?? '', this.offer?.isExternalOffer ? Validators.required : null],
      customerPromise: [this.offer?.customerPromise ?? '', Validators.maxLength(500)],
      duration: [this.offer?.duration ?? ''],
      openingPeriod: [this.offer?.openingPeriod ?? ''],
      informations: [this.offer?.informations ?? ''],
      services: [this.offer?.services ?? ''],
      environment: [this.offer?.environment ?? ''],
      prerequisites: [this.offer?.prerequisites ?? ''],
      price: [this.offer?.price ?? '', Validators.required],
      firstMainTag: [''],
      secondMainTag: [''],
      thirdMainTag: [''],
      advantage: [this.offer?.advantage ?? ''],
      photoExperience: [this.offer?.photoExperience ?? '', Validators.maxLength(this.maxFiftyLength)],
      parameters: this.formBuilder.array([]),
      licence: [null],
      licenceRequired: [this.offer?.licenceRequired ?? false],
      isInternalOffer: [this.offer ? !this.offer.isExternalOffer : false],
      offerSessionSettable: [this.offer?.isExternalOffer ?? false],
      hasSession: [this.offer?.hasSession ?? false],
      universes: [this.offer?.universes ?? []]
    })

    this.pricingForm = this.formBuilder.group({
      fixedPrice: [this.offer?.fixedPrice, [Validators.required, Validators.min(1)]],
      advancePayment: [{ value: this.offer?.advancePayment || 0, disabled: true }, Validators.required],
      isPayableAtClub: this.offer?.isPayableAtClub ? this.offer?.isPayableAtClub : false,
      isPayableOnline: this.offer?.isPayableOnline ? this.offer?.isPayableOnline : false,
      remAge: this.formBuilder.array([]),
      remQTE: this.formBuilder.array([]),
      remTFED: [''],
      remVRES: ['', [Validators.pattern(/[0-9]{5}/), Validators.maxLength(5)]],
      remVRESPercentage: [''],
      remStagiaires: this.formBuilder.array([]),
      cityRemVRES: this.formBuilder.array([])
    })

    if (this.offer?.mainTags) {
      this.f?.firstMainTag.setValue(this.offer?.mainTags[0]?.tagName);
      this.f?.secondMainTag.setValue(this.offer?.mainTags[1]?.tagName);
      this.f?.thirdMainTag.setValue(this.offer?.mainTags[2]?.tagName);

      //TODO a commenter pour les mainTags
      // this.filterMainTags('first', this.f?.firstMainTag);
      // this.filterMainTags('second', this.f?.secondMainTag);
    }

    this.form.get('clubCode').valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        if (value) {
          this.getPracticePlaceByClub();
        }
      })

    this.form.get('isInternalOffer').valueChanges
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((value) => {
        if (value) {
          this.f?.offerClubURL.reset();
          this.f?.offerClubURL.clearValidators();
        } else {
          this.f?.offerClubURL.setValidators([Validators.required])
        }
        this.f?.offerClubURL.updateValueAndValidity();
      })

  }

  private setValueForm(): void {
    if (this.userConnected.role === 'club') {
      this.f.clubCode.setValue(this.userConnected.club_code.toString());
      this.f.clubCode.disable();
    }
  }

  back(): void {
    const user = this.authService.getDecodedToken();

    this.editFinished.next();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  copyString(): void {
    const offerKey = this.offer.offerKey;
    const link = `${environment.urlSite}home/offer?offerKey=${offerKey}`;
    if (navigator.clipboard) { navigator.clipboard.writeText(link); }
  }

  async onSubmit() {
    if (this.tabSelectedIndex === 0) this.confirmDescription()
    else

      if (this.tabSelectedIndex === 1) this.confirmPricing();
  }


  //TODO a décommenter pour les mainTags
  private addMainTag(): void {
    const mainTagsNotFiltered = [];
    const firstMainTag = this.tagsSelected.find(t => t.tagName === this.f.firstMainTag.value);
    const secondMainTag = this.tagsSelected.find(t => t.tagName === this.f.secondMainTag.value);
    const thirdMainTag = this.tagsSelected.find(t => t.tagName === this.f.thirdMainTag.value);

    mainTagsNotFiltered.push(firstMainTag, secondMainTag, thirdMainTag);
    this.mainTags = mainTagsNotFiltered.filter(t => t !== undefined);
  }

  confirmDescription() {
    this.isLoading = true;
    let submit = false;
    if (this.form.invalid) { return; }

    let parameters: any[] = [];

    if (this.form.getRawValue().parameters.length > 0) {
      this.form.getRawValue().parameters.map((oneParam) => {
        let param = {
          parameterKey: oneParam.param.parameterKey,
          isFirstPage: oneParam.isFirstPage
        }
        parameters.push(param)
      })
    }

    if (!this.f.hasSession.value) {
      parameters = [];
    }

    this.addMainTag();

    this.newOffer = {
      offerName: this.f.offerName.value,
      clubCode: this.f.clubCode.value,
      image: null,
      oldImage: this.oldImage,
      description: this.f.description.value,
      offerClubURL: this.f.offerClubURL.value,
      practicePlace: this.f.practicePlace.value.label,
      practicePlaceKey: this.f.practicePlace.value.practicePlaceKey,
      customerPromise: this.f.customerPromise.value,
      duration: this.f.duration.value,
      openingPeriod: this.f.openingPeriod.value,
      informations: this.f.informations.value,
      services: this.f.services.value,
      environment: this.f.environment.value,
      price: this.f.price.value,
      prerequisites: this.f.prerequisites.value,
      tags: this.tagsSelected,
      mainTags: this.mainTags,
      advantage: this.f.advantage.value,
      photoExperience: this.f.photoExperience.value,
      universes: this.f.universes.value,
      parameters: parameters,
      isExternalOffer: !this.form.get('isInternalOffer').value,
      hasSession: this.f.hasSession.value,
      fixedPrice: this.offerPreview.fixedPrice,
      advancePayment: this.offerPreview.advancePayment,
      licenceRequired: this.f.licenceRequired.value
    };

    if (this.f.licenceRequired.value) {
      this.newOffer.licenceKey = this.f.licence.value.licenceKey;
    }



    switch (this.mode) {
      case 'add':

        if (!this.f.practicePlace.value) {
          this.uiService.showSnackbar('Vous devez selectionner un lieu de pratique');
          this.isLoading = false;
          break;
        }

        if (!this.f.isInternalOffer.value && !this.f.offerClubURL.value) {
          this.uiService.showSnackbar('Vous devez ajouter l\'url externe du club');
          this.isLoading = false;
          break;
        }

        if (!this.tagsSelected.length) {
          this.uiService.showSnackbar('Vous devez selectionner des tags');
          this.isLoading = false;
          break;
        }

        submit = true;

        if (submit) {
          this.newOffer.hasSession = this.f.hasSession.value;

          if (!this.f.isInternalOffer.value) {
            this.newOffer.advancePayment = 0;
            this.newOffer.fixedPrice = 0;
            this.newOffer.isExternalOffer = !this.f.isInternalOffer.value;
            this.newOffer.hasSession = false;
            this.offerService.addOffer(this.newOffer).subscribe({
              next: async (res) => {
                if (this.file) {
                  this.saveImgOffer(res, this.file, true);
                }

                this.uiService.showSnackbar(`Offre ajoutée`);

                this.editFinished.next(true);

                this.isLoading = false;
              },
              error: error => this.uiService.showSnackbar(error.error)
            });
          } else {
            // switch to tab pricing
            this.offer = this.newOffer;
            this.tabSelectedIndex = 1;
            this.isLoading = false;
          }
        }
        break;

      case 'edit':

        this.newOffer.offerKey = this.offerPreview.offerKey;
        this.newOffer.image = this.offerPreview.image;
        this.newOffer.isPayableAtClub = this.offerPreview.isPayableAtClub;
        this.newOffer.isPayableOnline = this.offerPreview.isPayableOnline;

        this.file === undefined ?
          this.file = null :
          this.file = this.file;

        if (!this.f.practicePlace.value) {
          this.uiService.showSnackbar('Vous devez selectionner un lieu de pratique');
          this.isLoading = false;
          break;
        }

        if (!this.f.isInternalOffer.value && !this.f.offerClubURL.value) {
          this.uiService.showSnackbar('Vous devez ajouter l\'url externe du club');
          this.isLoading = false;
          break;
        }

        if (!this.tagsSelected.length) {
          this.uiService.showSnackbar('Vous devez selectionner des tags');
          this.isLoading = false;
          break;
        }

        submit = true;

        if (submit) {

          this.newOffer.hasSession = this.f.hasSession.value;

          if (!this.f.isInternalOffer.value) {
            this.newOffer.advancePayment = 0;
            this.newOffer.fixedPrice = 0;
            this.newOffer.isExternalOffer = !this.f.isInternalOffer.value;
            this.newOffer.hasSession = false;

            this.offerService.updateOffer(this.newOffer).subscribe({
              next: (res) => {
                if (this.file) {
                  this.saveImgOffer(this.newOffer.offerKey, this.file, true);
                }

                this.uiService.showSnackbar('Offre modifiée');

                this.editFinished.next(true);

                this.isLoading = false;
              }
            });

          } else {
            this.offer = this.newOffer;
            this.tabSelectedIndex = 1;
            this.isLoading = false;
          }
        }
        break;

      default:
        break;
    }
  }

  confirmPricing() {
    const pricingOffer: PricingOffer = this.formatPricing();

    this.newOffer.isPayableAtClub = this.pricingForm.get('isPayableAtClub').value;
    this.newOffer.isPayableOnline = this.pricingForm.get('isPayableOnline').value;

    switch (this.mode) {
      case 'add':
        this.offerService.addOffer(this.newOffer).subscribe({
          next: async offerKey => {
            if (this.file) {
              this.saveImgOffer(offerKey, this.file, true);
            }

            pricingOffer.offerKey = await offerKey;

            this.offerService.addOfferPricing(pricingOffer).subscribe({
              next: () => {

                if (this.form.get('hasSession').value) {

                  const dialogRef = this.dialog.open(OpenDialogGoToOfferSessionComponent);

                  dialogRef.afterClosed().subscribe({
                    next: () => {
                      this.newOffer.offerKey = offerKey;
                      this.switchToSession.next(this.newOffer);
                    }
                  });
                } else {
                  this.uiService.showSnackbar(`Offre ajoutée`);

                  this.editFinished.next(true);

                  this.isLoading = false;

                }
              }
            });

          },
          error: error => {
            this.uiService.showSnackbar(error.error);
          },
        });
        break;

      case 'edit':
        this.offerService.updateOffer(this.newOffer).subscribe({
          next: () => {
            if (this.file) {
              this.saveImgOffer(this.newOffer.offerKey, this.file, true);
            }

            pricingOffer.offerKey = this.newOffer.offerKey;

            this.offerService.updateOfferPricing(pricingOffer).subscribe({
              next: () => {

                this.uiService.showSnackbar('Offre modifiée');

                this.editFinished.next(true);

                this.isLoading = false;
              }
            });

          },
          error: error => { console.error(error); },
        });
        break;

      default:
        break;
    }
  }

  private formatPricing(): PricingOffer {
    const pricing: Pricing[] = [new Pricing(null, this.pricingF.fixedPrice.value)];
    this.pricingF.remAge.value.forEach(el => {
      const limit = `${el.limits[0].min}#${el.limits[0].max}`;
      const rem = new Pricing(limit, el.price);
      pricing.push(rem);
    });

    const discount: Discount[] = [];
    discount.push(new Discount('RemQTE', this.pricingF.remQTE?.value[0]?.quantity || 0, this.pricingF.remQTE?.value[0]?.reduction));
    discount.push(new Discount('RemTFED', null, this.pricingF.remTFED?.value));
    discount.push(new Discount('RemRES', this.pricingF.cityRemVRES.value.join('#'), this.pricingF.remVRESPercentage?.value));
    discount.push(new Discount('RemStagiaires', this.pricingF.remStagiaires?.value[0]?.quantity || 0, this.pricingF.remStagiaires?.value[0]?.reduction));

    const pricingOffer: PricingOffer = {
      advancePayment: this.pricingF.advancePayment.value,
      fixedPrice: this.pricingF.fixedPrice.value,
      isPayableAtClub: this.pricingF.isPayableAtClub.value,
      isPayableOnline: this.pricingF.isPayableOnline.value,
      pricing,
      discount,
    };
    return pricingOffer;
  }

  disabledToggle(): void {
    this.uiService.showSnackbar('Modification impossible: l\'offre est présente dans un panier ou a déjà été réservée');
  }

  checkForm(): boolean {
    const newOfferCheck = new FullOffer();
    if (this.mode === 'add') {
      newOfferCheck.offerName = this.f.offerName.value || null;
      newOfferCheck.clubCode = this.f.clubCode.value || null;
      newOfferCheck.description = this.f.description.value || null;
      newOfferCheck.practicePlace = this.f.practicePlace.value || null;
      newOfferCheck.price = this.f.price.value || null;
    } else if (this.mode === 'edit') {
      this.offerPreview.practicePlace = this.f.practicePlace.value || null;
    }

    const o = this.mode === 'add' ? newOfferCheck : this.offerPreview;
    const check = o?.offerName && o?.clubCode && o?.description && o?.price && o?.practicePlace && this.tagsSelected?.length;


    if (this.form.invalid) {
      return false;
    }


    return this.f.isInternalOffer.value ? check >= 0 : (check >= 0 && this.f.offerClubURL.value) ? true : false;
  }

  filterMainTags(mainTag: string, { value }) {

    switch (mainTag) {
      case 'first':

        if (this.tagsSelected !== undefined) {
          this.tagsSelectedSecondMainTag = [... this.tagsSelected];
          const indexFirstTag = this.tagsSelectedSecondMainTag.findIndex(item => item.tagName === value);
          this.tagsSelectedSecondMainTag.splice(indexFirstTag, 1);
          this.tagsSelectedThirdMainTag = [...this.tagsSelectedSecondMainTag];

          if (this.f.secondMainTag.value) {
            if (value === this.f.secondMainTag.value) { this.f.secondMainTag.setValue(''); }
            if (value === this.f.thirdMainTag.value) { this.f.thirdMainTag.setValue(''); }
          }

        }
        break;

      case 'second':

        if (this.tagsSelectedSecondMainTag !== undefined) {
          this.tagsSelectedThirdMainTag = [...this.tagsSelectedSecondMainTag];

          const indexSecondtTag = this.tagsSelectedSecondMainTag.findIndex(item => item.tagName === value);
          this.tagsSelectedThirdMainTag.splice(indexSecondtTag, 1);

          if (value === this.f.firstMainTag.value) { this.f.firstMainTag.setValue(''); }
          if (value === this.f.thirdMainTag.value) { this.f.thirdMainTag.setValue(''); }
        }
        break;

      case 'third':
        if (this.f.secondMainTag.value) {
          if (value === this.f.firstMainTag.value) { this.f.firstMainTag.setValue(''); }
          if (value === this.f.secondMainTag.value) { this.f.secondMainTag.setValue(''); }
        }

        break;

      default:
        break;
    }
  }

  updatePreviewOffer(input: string, event?): void {
    this.offerPreview.clubCode = this.userConnected.role === 'club' ? this.userConnected.club_code : this.f.clubCode?.value;
    switch (input) {
      case 'offerName':
        this.offerPreview.offerName = this.f.offerName?.value;
        this.dataService.titleAdminOffer.next(this.f.offerName?.value);
        break;
      case 'description':
        this.offerPreview.description = this.f.description?.value;
        break;
      case 'duration':
        this.offerPreview.duration = this.f.duration?.value;
        break;
      case 'practicePlace':
        this.offerPreview.practicePlace = this.f.practicePlace?.value;
        break;
      case 'price':
        this.offerPreview.price = this.f.price?.value;
        break;
      case 'image':
        this.oldImage = this.offerPreview?.image ? JSON.parse(JSON.stringify(this.offerPreview?.image)) : '';
        const file = event?.target.files[0];

        const type = file.type?.split('/')[1];
        const limitSize = 300000;

        (['jpeg', 'png'].includes(type)) ?
          (file.size <= limitSize ?
            (reader.readAsDataURL(file),
              reader.onload = (res) => {
                this.file = file;
                this.offerPreview.image = reader.result.toString() || this.imgOfferDefault.imgDefault;
                this.imageUpdate.next(reader.result.toString())
              }) :
            this.uiService.showSnackbar('la taille de l\'image de doit pas être suppérieure à 300kB')) :
          this.uiService.showSnackbar('Uniquement format jpg ou png');

        break;
      default:
        break;
    }

    // this.formIsValid();
    this.offerPreview.hasSession = this.f.hasSession.value;
    this.offerPreview.isExternalOffer = !this.f.isInternalOffer.value;

    this.offerPreviewUpdate.next(this.offerPreview);

  }

  get f() {
    return this.form?.controls;
  }

  get pricingF() {
    return this.pricingForm?.controls;
  }

  get selectionParameters(): UntypedFormArray {
    return this.form.controls.parameters as UntypedFormArray;
  }

  get selectionParameterRequired(): UntypedFormArray {
    return this.form.controls.parameterRequired as UntypedFormArray;
  }

  getselectionParametersRequiredValues(index: number): UntypedFormArray {
    return this.selectionParameterRequired.controls[index]['controls'].values as UntypedFormArray;
  }

  getselectionParametersValues(index: number): UntypedFormArray {
    return this.selectionParameters.controls[index]['controls'].values as UntypedFormArray;
  }

  getPracticePlaceByClub(): void {
    let clubCode: string;

    switch (this.userConnected?.role) {
      case 'admin':
        clubCode = this.f.clubCode.value;
        break;

      case 'club':
        clubCode = this.userConnected.club_code;
        break;

      default:
        break;
    }

    if (!this.clubCode) {
      if (clubCode?.length) {

        this.practicePlaceService.getPracticePlaceByClub(clubCode).subscribe({
          next: async practiceClub => {

            if (this.mode === 'add' && practiceClub?.length === 1) {
              setTimeout(() => this.f.practicePlace.setValue(practiceClub[0]));
            }

            this.practicesClub = practiceClub;
            const practicePlaceToOffer = await practiceClub?.find(pp => pp?.practicePlaceKey === this.offerPreview?.practicePlaceKey);
            this.f.practicePlace.setValue(practicePlaceToOffer);
          }
        });
      }
    }
  }

  getTooltip(value: string): string {
    return this.tooltip.getTooltip(value);
  }

  private prepareOfferToForm(): void {
    if (this.offer) {
      this.offerService.getOfferById(this.offer.offerKey).subscribe({
        next: async offerById => {
          this.offer = offerById;
          this.offerKey = offerById.offerKey;
          this.offerPreview = this.offer;

          this.getPracticePlaceByClub();

          this.isLoading = false;

          this.mode !== 'add' ?
            this.dataService.tagSelectedAddOffer.next(this.offerPreview?.tags) :
            this.dataService.tagSelectedAddOffer.next([]);
        }
      });

    } else {
      this.mode !== 'add' ?
        this.dataService.tagSelectedAddOffer.next(this.offerPreview?.tags) :
        this.dataService.tagSelectedAddOffer.next([]);
    }
  }

  private saveImgOffer(offerKey: number, file: any, isMainPicture?: boolean): void {
    this.offerService.uploadImg(offerKey, [file], isMainPicture ? true : false).subscribe({
      next: () => { }
    });
  }

  getArray(array: string): UntypedFormArray {
    return this.form.get(array) as UntypedFormArray;
  }

  dataURLtoFile(dataurl, filename) {

    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  updateFile(event) {
    this.file = event;
  }

  getTooltipText(values, type): string {
    let valueConvert = [];

    const valuesSplit = values.split('#');
    switch (type) {
      case 'valeur min/max':
        valueConvert = [
          {
            name: 'Min:',
            value: valuesSplit[0]
          },
          {
            name: 'Max:',
            value: valuesSplit[1]
          },
        ];
        break;

      case 'liste':
        valueConvert = [];
        valuesSplit.forEach((v, index) => {
          const value = {
            name: ``,
            value: v
          };
          valueConvert.push(value);
        });

        break;

      case 'checkbox':
        valueConvert = [];
        valuesSplit.forEach((v, index) => {
          const value = {
            name: `Case ${index + 1}:`,
            value: v
          };
          valueConvert.push(value);
        });
        break;

      default:
        valueConvert = [];
        break;

    }

    let string = '';

    valueConvert.map((param, index) => {
      string += param.name + ' ' + param.value;

      if (index + 1 !== valueConvert.length) {
        string += ', '
      }
    })

    return string;
  }

  onTabChanged(event) {
    if (event.index === 1) this.confirmDescription();
  }
}
